export default "__VITE_ASSET__BcHHqy4H__"